import ReactDOMServer from 'react-dom/server';
import parse from 'html-react-parser';

export const printReceipt = (divContent) => {
  const previewContent = (
    <html lang="en">
      <head>
        <title>ORDER RECEIPT</title>
        <link
          rel="stylesheet"
          href="https://www.artscentremelbourne.com.au/assets/css/style.min.css"
        />
      </head>
      <body className="order-receipt-print">
        <h2>Order Receipt</h2>
        <hr className="hr-double" />
        {parse(divContent)}
      </body>
    </html>
  );
  const previewWindow = window.open('', 'print div', 'height=800,width=1000');
  previewWindow.document.write(ReactDOMServer.renderToStaticMarkup(previewContent));

  // necessary for IE >= 10
  previewWindow.document.close();
  // necessary for IE >= 10
  previewWindow.focus();

  setTimeout(() => {
    previewWindow.print();
  }, 1000);

  return true;
};
